import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../../util/Util";
import {
  checkIfCompanyUrlExists,
  createCompany,
  updateCompany,
} from "../../../actions/company/company";

class CompanyAddGeneralInfoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company_name: undefined,
      url: undefined,
      company_nameError: null,
      urlError: null,
    };
    if (this.props.company !== undefined) {
      this.state = {
        company_name: this.props.company.name,
        url: this.props.company.url,
      };
    }
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    let data = {};

    // No previous error
    if (this.hasError()) return;

    if (this.props.company === undefined) {
      data = {
        name: this.state.company_name,
        url: this.state.url,
      };

      // Send company information and redirect on success
      this.props.onCompanyCreate(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    } else {
      data = {
        _id: this.props.company._id,
        name: this.state.company_name,
        url: this.state.url,
      };
      // Send company information and redirect on success
      this.props.onCompanyEdit(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    }
  }

  hasEmptyField() {
    return !this.state.company_name || !this.state.url;
  }

  hasError() {
    return this.state.urlError || this.state.company_nameError;
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    // Check if company_name is not empty
    if (field === "company_name" && !Util.emptyString(value)) {
      this.setState({ company_nameError: null });
      // Check if company_name < 50
      if (value.length > 50) {
        this.setState({
          company_nameError: <FormattedMessage id="Caractere.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[A-Z.\s0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          company_nameError: <FormattedMessage id="Caractere.Type" />,
        });
      }
    }

    // Check if email is not empty and not already taken
    if (field === "url" && !Util.emptyString(value)) {
      this.setState({ urlError: null });
      this.props.onCheckIfCompanyUrlExists(value, () => {
        this.setState({
          urlError: <FormattedMessage id="URL.Already.Taken" />,
        });
      });

      if (value.length > 20) {
        this.setState({
          urlError: <FormattedMessage id="Caractere.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[a-z0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          urlError: <FormattedMessage id="Caractere.Type.AlphaNum" />,
        });
      }
    }
  }

  render() {
    return (
      <div className="modal-body">
        <form onSubmit={(e) => this.handleSubmit(e)} autoComplete="off">
          <div className="form-group row">
            <label htmlFor="date" className="col-5 col-form-label">
              <FormattedMessage id="Company.Name" />
            </label>
            <div className="col-7">
              <input
                type="text"
                id="company_name"
                name="company_name"
                className="form-control"
                defaultValue={this.state.company_name}
                onInput={(e) =>
                  (e.target.value = ("" + e.target.value).toUpperCase())
                }
                onChange={(e) =>
                  this.onChange("company_name", "" + e.target.value)
                }
              />
              <small className="text-danger">
                {this.state.company_nameError}
              </small>
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="date" className="col-5 col-form-label">
              <FormattedMessage id="URL.Company" />
            </label>
            <div className="col-7">
              <input
                type="text"
                id="url"
                name="url"
                defaultValue={this.state.url}
                onInput={(e) =>
                  (e.target.value = ("" + e.target.value).toLowerCase())
                }
                className="form-control"
                onChange={(e) => this.onChange("url", e.target.value)}
              />
              <small className="text-danger">{this.state.urlError}</small>
            </div>
          </div>

          {this.props.company === undefined && (
            <div className="row mt-4">
              <div className="col-4 m-auto">
                <button
                  type="submit"
                  disabled={
                    this.hasEmptyField() ||
                    this.state.company_nameError ||
                    this.state.urlError
                  }
                  className="btn btn-info btn-block button-info right"
                >
                  <FormattedMessage id="Create" />
                </button>
              </div>
            </div>
          )}
          {this.props.company !== undefined && (
            <div className="row mt-4">
              <div className="col-4 m-auto">
                <button
                  type="submit"
                  disabled={
                    this.hasEmptyField() ||
                    this.state.company_nameError ||
                    this.state.urlError
                  }
                  className="btn btn-info btn-block button-info right"
                >
                  <FormattedMessage id="Edit" />
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheckIfCompanyUrlExists: (url, existsCallback, noExistsCallback) =>
      checkIfCompanyUrlExists(url, existsCallback, noExistsCallback),
    onCompanyCreate: (data, successCallback, failureCallback) =>
      dispatch(createCompany(data, successCallback, failureCallback)),
    onCompanyEdit: (data, successCallback, failureCallback) =>
      dispatch(updateCompany(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyAddGeneralInfoModal));
